import React, { useMemo, useState } from 'react';
import { Button, Dropdown, Form, Modal } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import modalContainer from 'packages/common/modalContainer';

const LANGUAGE_OPTIONS = [
    { value: null, label: 'Auto' },
    { value: 'en-US', label: 'English' },
    { value: 'es-ES', label: 'Spanish' },
    { value: 'fr-FR', label: 'French' },
    { value: 'de-DE', label: 'German' },
    { value: 'nl-NL', label: 'Dutch' },
] as const;

type Props = {
    isGenerating: boolean;
    onGenerate: (language: string | null) => void;
    onCancel: () => void;
};

const TranscriptGenerateModal = ({ isGenerating, onGenerate, onCancel }: Props) => {
    const { translate } = useTranslate();
    const [selectedLanguage, setSelectedLanguage] = useState<(typeof LANGUAGE_OPTIONS)[number]['value']>(
        LANGUAGE_OPTIONS[0].value,
    );

    // const selectedOption = useMemo(
    //     () => LANGUAGE_OPTIONS.find((opt) => opt.value === selectedLanguage),
    //     [selectedLanguage],
    // );

    return (
        <Modal
            container={modalContainer}
            title={
                isGenerating
                    ? translate('editor.transcript.modal.title.generating')
                    : translate('editor.transcript.modal.title')
            }
            isOpen
            isCloseButtonHidden={isGenerating}
            onClose={onCancel}
            actionPrimary={
                !isGenerating ? (
                    <Button variant="primary" onClick={() => onGenerate(selectedLanguage)}>
                        {translate('editor.transcript.modal.generate')}
                    </Button>
                ) : undefined
            }
            actionSecondary={
                !isGenerating ? (
                    <Button variant="secondary" onClick={onCancel}>
                        {translate('editor.transcript.modal.cancel')}
                    </Button>
                ) : (
                    <Button variant="secondary" onClick={onCancel}>
                        {translate('editor.transcript.modal.close')}
                    </Button>
                )
            }
        >
            {isGenerating ? (
                <p>{translate('editor.transcript.modal.generating')}</p>
            ) : (
                <>
                    <p>{translate('editor.transcript.modal.description')}</p>
                    {/* <Form.Group>*/}
                    {/*    <Form.Label>{translate('editor.transcript.modal.language-label')}</Form.Label>*/}
                    {/*    <Dropdown*/}
                    {/*        trigger={({ isOpen, ...triggerProps }) => (*/}
                    {/*            <Button isPressed={isOpen} rightIcon={<Dropdown.Arrow />} isFullWidth {...triggerProps}>*/}
                    {/*                <Dropdown.SelectButtonText>{selectedOption?.label}</Dropdown.SelectButtonText>*/}
                    {/*            </Button>*/}
                    {/*        )}*/}
                    {/*    >*/}
                    {/*        {LANGUAGE_OPTIONS.map((option) => (*/}
                    {/*            <Dropdown.Item*/}
                    {/*                key={option.value}*/}
                    {/*                isChecked={selectedLanguage === option.value}*/}
                    {/*                onClick={() => setSelectedLanguage(option.value)}*/}
                    {/*            >*/}
                    {/*                {option.label}*/}
                    {/*            </Dropdown.Item>*/}
                    {/*        ))}*/}
                    {/*    </Dropdown>*/}
                    {/* </Form.Group>*/}
                </>
            )}
        </Modal>
    );
};

export default TranscriptGenerateModal;
